import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function LegalPrivacy() {
  const { t } = useTranslation();
  return (
    <article className="max-w-prose mx-auto px-8 py-16 prose-fyd">
      <span className="section-eyebrow">{t('legal.eyebrow')}</span>
      <h1 className="font-serif text-4xl font-medium mb-2">{t('legal.privacy.title')}</h1>
      <p className="font-mono text-[11px] tracking-meta uppercase text-ink-3 mb-12">
        {t('legal.lastUpdated')} 2026-05-02
      </p>

      <section className="space-y-8 text-base leading-relaxed text-ink">
        <div>
          <h2 className="font-serif text-2xl font-medium mb-3">1. {t('legal.privacy.h1')}</h2>
          <p className="text-ink-2">{t('legal.privacy.p1')}</p>
        </div>
        <div>
          <h2 className="font-serif text-2xl font-medium mb-3">2. {t('legal.privacy.h2')}</h2>
          <p className="text-ink-2">{t('legal.privacy.p2')}</p>
        </div>
        <div>
          <h2 className="font-serif text-2xl font-medium mb-3">3. {t('legal.privacy.h3')}</h2>
          <p className="text-ink-2">{t('legal.privacy.p3')}</p>
        </div>
        <div>
          <h2 className="font-serif text-2xl font-medium mb-3">4. {t('legal.privacy.h4')}</h2>
          <p className="text-ink-2">{t('legal.privacy.p4')}</p>
        </div>
      </section>

      <p className="text-sm text-ink-3 mt-12">
        {t('legal.contact')}{' '}
        <a href="mailto:support@fyd.dev" className="text-ink border-b border-current pb-px">
          support@fyd.dev
        </a>
      </p>
      <p className="text-sm text-ink-3 mt-4">
        <Link to="/legal/terms" className="text-ink border-b border-current pb-px">
          {t('legal.terms.title')}
        </Link>
      </p>
    </article>
  );
}
